import { BASE_URL } from '@config/environment';
import { Product } from '@interfaces';
import { availabilityToSchema } from '@utils';
import { ProductJsonLd as JsonLd } from 'next-seo';
const obtainJsonLd = (product: Product) => {
  const {
    name,
    concentration,
    thumbnailUrl,
    quantity,
    format,
    activePrinciple,
    laboratory,
    price,
    slug,
    prescriptionType,
    availability,
  } = product;
  return {
    productName: `${name}${concentration ? ' ' + concentration : ''}`
      .trim()
      .replace(/s+/, ' '),
    images: [thumbnailUrl],
    description:
      (quantity?.toString() ?? '') +
      ' ' +
      format +
      (activePrinciple ? ` • ${activePrinciple}` : ' ') +
      (laboratory ? ` • ${laboratory}` : ''),

    brand: laboratory,
    offers: {
      price: ['HIDDEN', 'UNAVAILABLE', 'SOLD_OUT'].includes(
        availability?.status,
      )
        ? null
        : String(price),
      priceCurrency: 'CLP',
      seller: { name: 'Meki' },
      url: `${BASE_URL}/producto/${slug}`,
      availability: `https://schema.org/${
        prescriptionType !== 'CHECK'
          ? availabilityToSchema[availability?.status] ?? 'LimitedAvailability'
          : 'InStoreOnly'
      }`,
    },
  };
};

interface ProductJsonLdProps {
  product: Product;
}
export const ProductJsonLd = (props: ProductJsonLdProps) => {
  const { product } = props;
  if (!product) return null;
  return <JsonLd {...obtainJsonLd(product)} />;
};
